<template>
  <div class="dashboard" v-if="initialized">
    <Clock class="widget" />
    <Astronomy class="widget" />
    <Weather class="widget" />
    <Countdown class="widget countdown" />
    <!-- <div class="widget"></div> -->
    <CatPicture class="widget" />
    <Calendar class="widget" />
    <Quote class="widget cols-3" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Astronomy from '@/components/Astronomy.vue';
import Calendar from '@/components/Calendar.vue';
import CatPicture from '@/components/CatPicture.vue';
import Clock from '@/components/Clock.vue';
import Countdown from '@/components/Countdown.vue';
import Quote from '@/components/Quote.vue';
import Weather from '@/components/Weather.vue';

export default {
  name: 'Dashboard',
  components: {
    Astronomy,
    Calendar,
    CatPicture,
    Clock,
    Countdown,
    Quote,
    Weather,
  },
  computed: {
    ...mapState(['initialized']),
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions({ initData: 'init' }),
  },
};
</script>

<style>
/* TODO: Use the grid property instead of float */
.dashboard {
  width: 100%;
  height: 100%;
}
.widget {
  width: 33%;
  height: 33%;
  float: left;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.widget.countdown {
  flex-direction: column;
}

.widget.cols-3 {
  width: 100%;
}

* {
  font-family: "Source Sans Pro", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
}
</style>
